import React from 'react';
import { HomepagesCell, MenuCell, AnnouncementCell } from '../components';

/**
 * Build column definitions for Mobile Teams page
 */
export function buildMobileTeamsColumnDefs({
  homepagesById,
  menuById,
  announcementById,
  createHomepageClicked,
  setPreviewPanel,
  setDialog
}) {
  return [
    {
      id: 'teamLabel',
      displayName: 'Teams',
      width: 240,
      fixed: true,
      isLastFixedColumn: true,
      customHeaderCellStyle: 'coach-teams-column'
    },
    {
      id: 'homepages',
      displayName: 'Homepages',
      width: 480,
      CellRenderer: ({ record }) => (
        <HomepagesCell
          data={record}
          homepagesById={homepagesById}
          createHomepageClicked={createHomepageClicked}
          setPreviewPanel={setPreviewPanel}
          setDialog={setDialog}
        />
      ),
      customHeaderCellStyle: 'coach-homepages-column'
    },
    {
      id: 'menu',
      displayName: 'Menus',
      width: 323,
      CellRenderer: ({ record }) => <MenuCell data={record} menuById={menuById} />,
      customHeaderCellStyle: 'coach-menus-column'
    },
    {
      id: 'announcement',
      displayName: 'Announcements',
      width: 323,
      CellRenderer: ({ record }) => (
        <AnnouncementCell data={record} announcementById={announcementById} />
      )
    }
  ];
}
